import { render, staticRenderFns } from "./scienceZx.vue?vue&type=template&id=5e7a41a6&scoped=true&"
import script from "./scienceZx.vue?vue&type=script&lang=js&"
export * from "./scienceZx.vue?vue&type=script&lang=js&"
import style0 from "./scienceZx.vue?vue&type=style&index=0&id=5e7a41a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7a41a6",
  null
  
)

component.options.__file = "scienceZx.vue"
export default component.exports